var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;clip-path:url(#SVGID_00000177482491098802401300000011709410064803354532_);}\n\t.st1{display:inline;fill:#FF669B;}\n\t.st2{clip-path:url(#SVGID_00000047754799816430571850000013309200742797921708_);}\n\t.st3{fill:#FF669B;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016045960476284859280000008696087659083821485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none",
      clipPath: "url(#SVGID_00000016045960476284859280000008696087659083821485_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9c2.4,2.4,5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2 c0.8-0.8,1.2-1.9,1.2-3s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 c-0.8,0.8-1.2,1.9-1.2,3v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000182491063742807653230000008230895163603280018_",
    x: 0.2,
    y: 2.7,
    width: 102.5,
    height: 102.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085940153640968761510000016341373089914975880_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182491063742807653230000008230895163603280018_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085940153640968761510000016341373089914975880_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.4,6.9H21.6c-5.7,0-11.1,2.3-15.1,6.3c-4,4-6.3,9.4-6.3,15.1v51.2c0,5.7,2.3,11.1,6.3,15.1 c4,4,9.4,6.3,15.1,6.3h59.8c5.7,0,11.1-2.3,15.1-6.3c4-4,6.3-9.4,6.3-15.1V28.3c0-5.7-2.3-11.1-6.3-15.1 C92.5,9.2,87.1,6.9,81.4,6.9L81.4,6.9z M21.6,15.5h59.8c2.6,0,5.1,0.8,7.2,2.2c2.1,1.4,3.8,3.5,4.7,5.8L60.6,56.2 c-2.4,2.4-5.7,3.7-9.1,3.7s-6.7-1.3-9.1-3.7L9.7,23.5c0.9-2.4,2.6-4.4,4.7-5.8S19,15.5,21.6,15.5L21.6,15.5z M81.4,92.4H21.6 c-3.4,0-6.7-1.3-9.1-3.8c-2.4-2.4-3.8-5.7-3.8-9.1V34.7l27.6,27.6c4,4,9.4,6.2,15.1,6.2s11.1-2.2,15.1-6.2l27.6-27.6v44.8 c0,3.4-1.3,6.7-3.8,9.1C88.1,91,84.8,92.4,81.4,92.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.930cc21e3ede1a6f9ba386ff2388321d.svg";
export { ForwardRef as ReactComponent };